// Copyright (c) 2021 WiseTime. All rights reserved.

import { Action } from "redux"
import { Observable } from "rxjs"
import { filter, map, tap } from "rxjs/operators"
import * as Actions from "../actions"
import { getLogoutPath } from "app/routing/urls"

export const redirectToLogOut = (): void =>
  window.location.replace(getLogoutPath())

export const logOut = (
  redirectToLogOut: () => void
) => (action$: Observable<Action>): Observable<Action> =>
  action$.pipe(
    filter(Actions.logOut.match),
    tap(_ => redirectToLogOut()),
    map(_ => Actions.logOutDone()),
  )

export default logOut(redirectToLogOut)
